export const isValidHex = (s: string): boolean => /^#[0-9A-Fa-f]{6}$/.test(s);
